function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M19.514 34.793h-3.141a1.05 1.05 0 0 1-1.048-1.047V23.485a1.05 1.05 0 0 1 1.048-1.047h3.14a1.05 1.05 0 0 1 1.048 1.047v10.26a1.05 1.05 0 0 1-1.047 1.048z"
}), React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M35.977 23.331h-7.853l2.618-3.979c.733-1.1.366-2.67-.838-3.298l-7.12 8.324h-2.251v8.376h3.036l.943.68c.733.577 1.727.89 2.722.89h6.439c.786 0 1.466-.523 1.466-1.308s-.68-1.309-1.466-1.309h.262c.89 0 1.623-.785 1.623-1.727 0-.733-.628-1.414-1.361-1.414h.68c.733 0 1.362-.576 1.362-1.309s-.629-1.308-1.362-1.308h1.047c.838 0 1.833-.576 1.833-1.414.052-.89-.943-1.204-1.78-1.204z"
}), React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M33.847 31.705H32.8M34.37 28.564h-1.047M35.417 25.947h-1.57"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/icon-post-approval.2c61d41b.svg";
export { SvgComponent as ReactComponent };